import {Component} from "@angular/core";

@Component({
  selector: "app-missing",
  templateUrl: "./missing.component.html"
})
export class MissingComponent {}
